// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nslqijO86HG_7_lmJPFu{margin-top:1.25rem}`, "",{"version":3,"sources":["webpack://./services/client/src/components/Header/components/LogoutButton/styles.module.scss"],"names":[],"mappings":"AAEA,sBACE,kBAAA","sourcesContent":["@import '../../../../styles/global.scss';\n\n.logoutBtn {\n  margin-top: pixel2rem(20);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoutBtn": `nslqijO86HG_7_lmJPFu`
};
export default ___CSS_LOADER_EXPORT___;
